import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable, Subject } from 'rxjs';
import { finalize, first, switchMap, takeUntil, tap } from 'rxjs/operators';
import { Account } from '../../models/account';
import { AccountService } from '../../services/account.service';
import { ModalService } from '../../services/modal.service';
import { FormGenerator } from '../../forms/form-generator';
import { FormHospitalOrNursingHomeStructure } from '../../forms/form-structure';
import { SiteService } from '../../services/site.service';

@Component({
  selector: 'app-account-hospital-and-nursing-home-list',
  templateUrl: './account-hospital-and-nursing-home-list.component.html',
  styleUrls: ['./account-hospital-and-nursing-home-list.component.scss'],
})
export class AccountHospitalAndNursingHomeListComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  account$: Observable<Account>;

  constructor(
    private siteService: SiteService,
    private modalService: ModalService,
    private accountService: AccountService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.account$ = this.accountService.account$;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onEditHospitalOrNursingHome(event: Event, hospitalOrNursingHome: any): void {
    const formGenerator = new FormGenerator();

    const formGroup = formGenerator.generate(
      FormHospitalOrNursingHomeStructure,
      hospitalOrNursingHome.value
    );

    const modal = this.modalService.addAccountHospitalOrNursingHome({
      title: 'Hospital / Nursing Home',
      buttons: [
        { label: 'Cancel', key: 'cancel', class: 'p-button-secondary' },
        { label: 'Save', key: 'save', class: '' },
      ],
      data: formGroup,
    });

    modal.onClose.subscribe({
      next: (reason: string) => {
        if (reason && reason.toString().toLowerCase() === 'save') {
          hospitalOrNursingHome.value = formGroup.value;
          hospitalOrNursingHome.name = formGroup.value.name;
          this.updateAccountData();
        }
      },
    });
  }

  onDeleteHospitalOrNursingHome(event: Event, hospitalOrNursingHome: any): void {
    const modal = this.modalService.generic({
      title: 'Remove Item',
      copy: ['Are you sure you want to remove this hospital / nursing home?'],
      buttons: [
        { label: 'Cancel', key: 'cancel', class: '' },
        { label: 'Confirm', key: 'confirm', class: 'p-button-danger', icon: 'pi pi-trash' },
      ],
    });

    modal.onClose.subscribe({
      next: (reason: string) => {
        if (reason.toString().toLowerCase() === 'confirm') {
          hospitalOrNursingHome.disabled = true;

          this.updateAccountData();
        }
      },
    });
  }

  onRestoreHospitalOrNursingHome(event: Event, hospitalOrNursingHome: any): void {
    const modal = this.modalService.generic({
      title: 'Restore Item',
      copy: ['Are you sure you want to restore this hospital / nursing home?'],
      buttons: [
        { label: 'Cancel', key: 'cancel', class: '' },
        { label: 'Confirm', key: 'confirm', class: 'p-button-success', icon: 'pi pi-refresh' },
      ],
    });

    modal.onClose.subscribe({
      next: (reason: string) => {
        if (reason.toString().toLowerCase() === 'confirm') {
          hospitalOrNursingHome.disabled = false;

          this.updateAccountData();
        }
      },
    });
  }

  private updateAccountData(): void {
    this.siteService.addSubscriptionLog(
      this,
      'account-hospital-and-nursing-home-list.component.ts->updateAccountData->this.accountService.account$'
    );

    this.accountService.account$
      .pipe(
        finalize(() =>
          this.siteService.setSubscriptionLogFinalised(
            'account-hospital-and-nursing-home-list.component.ts->updateAccountData->this.accountService.account$'
          )
        ),
        takeUntil(this.unsubscribe$),
        first(),
        switchMap((account) => this.accountService.patch(account.data))
      )
      .subscribe({
        next: (res) => {
          // console.log(res.data);
        },
      });
  }
}
